import React from 'react';
import HomeContent from './HomeContent';
import JobList from './JobList';
import JobCategory from '../jobcategory/JobCategory';


function Home() {
  return (
    <>
    <HomeContent />
    <JobList />
    <JobCategory />
    </>
  );
}

export default Home;